import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormValidationService } from 'src/app/service/form-validation/form-validation.service';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from 'src/app/core/shared/shared.module';
import { CommonAutocompleteComponent } from 'src/app/layouts/components/common-autocomplete/common-autocomplete.component';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LicenseeService } from '../../licensee/services/licensee.service';
import { SampleTypeService } from '../../master-data/sample-type/sample-type.service';
import { firstValueFrom } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'vex-add-quotation',
  standalone: true,
  imports: [
    CommonAutocompleteComponent,
    MatIconModule,
    MatDividerModule,
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatButtonModule,
    NgFor,
    NgIf
  ],
  templateUrl: './add-quotation.component.html',
  styleUrls: ['./add-quotation.component.scss']
})
export class AddQuotationComponent {
  form: FormGroup;
  uomDetails: any;
  inputTypeOptions: ('Alphanumeric' | 'Number' | 'Boolean')[] = [
    'Alphanumeric',
    'Number',
    'Boolean'
  ];
  companyList: any[] = [];
  sampleTypeList: any[] = [];
  programDetails: any;
  paymentMethodLIst: any[] = [
    { id: 'card', value: 'Card' },
    { id: 'wire/ach', value: 'Wired/ACH' }
    // { id: 'wire', value: 'Wired' },
    // { id: 'ach', value: 'ACH' }
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<AddQuotationComponent>,
    private fb: FormBuilder,
    private formValidationService: FormValidationService,
    private toastr: ToastrService,
    private licenseService: LicenseeService,
    private sampleTypeService: SampleTypeService
  ) {
    console.log(data);
    this.programDetails = data.programDetails;
  }

  ngOnInit() {
    this.getSampleType();
    this.inIt();
  }
  async getSampleType() {
    let resp = await firstValueFrom(this.sampleTypeService.getAllSampleType());
    this.getSampleTypeList(resp.items);
  }

  getSampleTypeList(ev: any) {
    let data: any = ev;
    this.sampleTypeList = [];
    if (this.programDetails && this.programDetails.sampleManagementList) {
      this.programDetails.sampleManagementList.forEach(
        (programSampleList: any) => {
          data.forEach((sampleData: any) => {
            if (sampleData.id == programSampleList.sampleTypeId) {
              if (programSampleList.status) {
                this.sampleTypeList.push({
                  id: sampleData.id,
                  programId: this.programDetails.id,
                  name: sampleData.name,
                  processFlowId: programSampleList.processFlowId,
                  sampleType: programSampleList.sampleType,
                  price: parseFloat(sampleData.price),
                  ab: sampleData.sampleTypeAb
                });
              }
            }
          });
        }
      );
    }
  }
  inIt() {
    this.form = this.fb.group({
      company: [''],
      sampleType: [''],
      paymentMethod: ['card'],
      price: ['']
    });
    this.licenseService.getLicenseeAll().subscribe((resp) => {
      this.companyList = resp.items;
    });
  }

  get isEdit(): boolean {
    return !!this.uomDetails?.id;
  }

  onSubmit() {
    if (this.form.invalid) {
      this.formValidationService.validateAllFormFieldsWithoutScroll(this.form);
      return;
    }

    console.log(this.form.value);
  }

  onCompanySelection(ev: MatAutocompleteSelectedEvent): any {
    const i = ev.option.value;
    this.form.get('company')?.setValue(i.id);
  }
}
